import { render, staticRenderFns } from "./Relogin.vue?vue&type=template&id=5352b668"
import script from "./Relogin.vue?vue&type=script&lang=js"
export * from "./Relogin.vue?vue&type=script&lang=js"
import style0 from "./Relogin.vue?vue&type=style&index=0&id=5352b668&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myagent\\_work\\14\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5352b668')) {
      api.createRecord('5352b668', component.options)
    } else {
      api.reload('5352b668', component.options)
    }
    module.hot.accept("./Relogin.vue?vue&type=template&id=5352b668", function () {
      api.rerender('5352b668', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Relogin.vue"
export default component.exports